export default "__VITE_ASSET__O4ozAG20__"